<template>
  <MenuContainer>
    <template #header>
      <MenuTitle slot="header" text="Row Settings">
        <template #prepend>
          <sp-button size="small" icon="arrow-left-filled" accessible-name="Back" @click="close"></sp-button>
        </template>
      </MenuTitle>
    </template>
    <sp-tab-group aria-label="Row Settings">
      <sp-tab slot="nav" panel="configuration">Configuration</sp-tab>
      <sp-tab slot="nav" panel="style">Style</sp-tab>

      <sp-tab-panel name="configuration">
        <Configuration v-model="model" />
      </sp-tab-panel>
      <sp-tab-panel name="style">
        <StyleOptions v-model="model" />
      </sp-tab-panel>
    </sp-tab-group>
  </MenuContainer>
</template>

<script setup>
import { computed } from "vue";
import MenuContainer from "#ce/components/SpLayoutBuilder/components/LayoutBuilderContextMenu/ContextMenuContainer.ce.vue";
import MenuTitle from "#ce/components/SpLayoutBuilder/components/LayoutBuilderContextMenu/ContextMenuTitle.ce.vue";
import Configuration from "./Configuration/Configuration.ce.vue";
import StyleOptions from "./StyleOptions/StyleOptions.ce.vue";

const emit = defineEmits(["close", "update:modelValue"]);

const props = defineProps({
  modelValue: {
    type: Object,
    required: true,
  },
});

const model = computed({
  get: () => props.modelValue,
  set: (value) => emit("update:modelValue", value),
});

function close() {
  emit("close");
}
</script>

<style scoped lang="scss">
sp-tab[active="true"]::part(activator) {
  --sp-comp-button-font-short: var(--sp-sys-form-field-label-short);
  --sp-comp-button-letter-spacing: -0.035ch !important;
}
</style>
